import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout, Spin } from "antd";

// Lazy imports
const IndividualCopingForm = lazy(() =>
  import("../components/IndividualCopingForm")
);
const SurveyEWB1 = lazy(() => import("../components/SurveyEWB1"));
const SurveyEWB2 = lazy(() => import("../components/SurveyEWB2"));
const SurveyPWB = lazy(() => import("../components/SurveyPWB"));
const SurveySWB = lazy(() => import("../components/SurveySWB"));
const SurveyFeeling = lazy(() => import("../components/SurveyFeeling"));
const RegistrationForm = lazy(() => import("../components/RegistrationForm"));

const SinglePage = lazy(() => import("../public/singlePage.jsx"));
const TeleEducation = lazy(() => import("../public/TeleEducation.jsx"));
const Profile = lazy(() => import("../pages/Profile"));
const MainLayout = lazy(() => import("../Layout/main.jsx"));
const NoMatch = lazy(() => import("../public/NoMatch"));
const Forms = lazy(() => import("../components/Forms"));
const Welcome = lazy(() => import("../pages/Welcome"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const SpeechRecognitionComponent = lazy(() =>
  import("../pages/SpeechRecognition")
);
const TeleAtencion = lazy(() => import("../public/TeleAtencion.jsx"));
const Blogs = lazy(() => import("../pages/Blogs"));
const BlogDetail = lazy(() => import("../public/BlogDetail"));
const Investigators = lazy(() => import("../public/Investigators"));
const OnlineDashboard = lazy(() => import("../public/OnlineDashboard"));
const PrivacyPolicy = lazy(() => import("../public/PrivacyPolicy"));
const VideoMeeting = lazy(() => import("../pages/VideoMeeting"));

// // Import the PrivateRoute from the snippet above
// import { PrivateRoute } from "./components/PrivateRoute.jsx"; // Adjust path if needed

const { Content } = Layout;

const contentStyle = {
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  minHeight: "800px",
  alignItems: "center",
  lineHeight: "120px",
  color: "#fff",
};

export default function AuthRoutes() {
  // Otherwise, rely on the Suspense fallback or the PrivateRoute loading check
  return (
    <Suspense
      fallback={
        <Layout>
          <Content style={contentStyle}>
            <Spin size="large" />
          </Content>
        </Layout>
      }
    >
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<SinglePage />} />
        <Route path="/tele-educacion" element={<TeleEducation />} />
        <Route path="/tele-atencion" element={<TeleAtencion />} />
        <Route path="blogs">
          <Route index element={<Blogs />} />
          <Route path=":id" element={<BlogDetail />} />
        </Route>
        <Route path="/investigadores" element={<Investigators />} />
        <Route path="/tablero-online" element={<OnlineDashboard />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
        <Route path="care/video-meeting/:userId" element={<VideoMeeting />} />

        {/* Protected route - "care" */}
        <Route path="care" element={<MainLayout />}>
          <Route index element={<Welcome />} />
          <Route path="register" element={<RegistrationForm />} />
          <Route path="profile" element={<Profile />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route
            path="speech-recognition"
            element={<SpeechRecognitionComponent />}
          />

          <Route path="forms">
            <Route index element={<Forms />} />
            <Route path="ewb1/:id" element={<SurveyEWB1 />} />
            <Route path="ewb2/:id" element={<SurveyEWB2 />} />
            <Route path="pwb/:id" element={<SurveyPWB />} />
            <Route path="swb/:id" element={<SurveySWB />} />
            <Route path="feeling/:id" element={<SurveyFeeling />} />
            <Route
              path="individual-coping/:id"
              element={<IndividualCopingForm />}
            />
          </Route>
        </Route>

        {/* Catch-all for non-existent routes */}
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Suspense>
  );
}
